import { msg } from "../locales/translate";
import type { IPaymentSession } from "src/types/types";
import type { EntityAnalysisRequest } from "./statView/overviewBankAnalysis";
import { isOverviewEntity } from "../modules/overviewAnalysis/entities.mjs";

export interface TransactionAnalysisTarget {
	kind: "bank" | "email" | "card";
	title: string;
	entity?: EntityAnalysisRequest["bank"];
	missing: string;
	labelKey?: "paymentCard";
}

const available = (value: unknown): value is string => typeof value === "string" && !!value.trim() && !/^(unknown|n\/a|none|null|-+)$/i.test(value.trim());
const cardMask = /^\d{4,8}[.*•…xX\s-]+\d{4}$/;

export function transactionAnalysisTargets(session: IPaymentSession): TransactionAnalysisTarget[] {
	const email = [session.email, session.req?.customer?.email].find(value => available(value) && isOverviewEntity({ type: "email", value, label: value }));
	const bank = [session.institution, session.payload?.card?.bank].find(value => available(value) && isOverviewEntity({ type: "bank", value, label: value }));
	const mask = [session.instrument_name, session.payload?.card?.mask].find(value =>
		available(value) && cardMask.test(value));
	const card = [
		...(["card", "ap", "gp"].includes(session.instrument) ? [session.instrument_data] : []),
		session.payload?.card?.token,
	].find(value => available(value) && value.length <= 256 && !cardMask.test(value) && !/^\d{12,19}$/.test(value) && !/[\u0000-\u001f\u007f]/.test(value));
	return [
		{ kind: "bank", title: msg("message_dee7345c"), entity: bank ? { type: "bank", value: bank, label: bank } : undefined, missing: msg("message_14829f7f") },
		{ kind: "email", title: msg("email_969ccbd3"), entity: email ? { type: "email", value: email, label: email } : undefined, missing: msg("email_65f9965f") },
		{ kind: "card", title: msg("message_2751c910"), entity: card ? { type: "card", value: card, label: mask || msg("message_f20c2867") } : undefined, missing: msg("message_d6389ceb"), labelKey: card && !mask ? "paymentCard" : undefined },
	];
}

export function transactionAnalysisPeriod(createdAt: number | string, now = new Date()) {
	let end = typeof createdAt === "number" ? new Date(createdAt < 10_000_000_000 ? createdAt * 1000 : createdAt) : new Date(createdAt);
	if (!createdAt || Number.isNaN(end.getTime())) end = now;
	const to = end.toISOString().slice(0, 10);
	const start = new Date(`${to}T00:00:00Z`);
	start.setUTCDate(start.getUTCDate() - 29);
	return { from: start.toISOString().slice(0, 10), to };
}

export function validAnalysisPeriod(from: string, to: string) {
	const validDate = (value: string) => /^\d{4}-\d{2}-\d{2}$/.test(value) && !Number.isNaN(Date.parse(value)) && new Date(value).toISOString().slice(0, 10) === value;
	return validDate(from) && validDate(to) && from <= to;
}
